import Rest from '@services/Rest';

/**
 * @typedef {AchievementsService}
 */
export default class AchievementsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/achievements'
}
